import Particles from "react-tsparticles";
import { loadFull } from "tsparticles";

//https://codesandbox.io/s/condescending-brook-rr8u2?file=/src/App.js
const ParticlesBackground = () => {
    const particlesInit = async (main) => {
        console.log(main);
    
        // you can initialize the tsParticles instance (main) here, adding custom shapes or presets
        // this loads the tsparticles package bundle, it's the easiest method for getting everything ready
        // starting from v2 you can add only the features you need reducing the bundle size
        await loadFull(main);
      };
    
      const particlesLoaded = (container) => {
        console.log(container);
      };
    return(

    <Particles
      id="tsparticles"
      init={particlesInit}
      loaded={particlesLoaded}
      options={{
        backgroundMode: {
          enable: true,
          zIndex: 0
        },
        background: {
          color: "#004C83"
        },
        fpsLimit: 120,
        interactivity: {
          detectsOn: "canvas",
          events: {
            onClick: { enable: true, mode: "repulse" },
            onHover: {
              enable: true,
              mode: "bubble",
              parallax: { enable: false, force: 2, smooth: 10 }
            },
            resize: true
          },
          modes: {
            bubble: {
              distance: 400,
              duration: 1.2,
              opacity: 1,
              size: 1,
              speed: 2
            },
            grab: { distance: 200, line_linked: { opacity: 0.5 } },
            push: { particles_nb: 4 },
            remove: { particles_nb: 2 },
            repulse: { distance: 200, duration: 0.4 }
          }
        },
        particles: {
          color: { value: "#fff" },
          links: {
            color: "#ffffff",
            distance: 500,
            enable: false,
            opacity: 0.4,
            width: 2
          },
          move: {
            attract: { enable: false, rotateX: 600, rotateY: 1200 },
            direction: "bottom",
            enable: true,
            outMode: "out",
            random: false,
            size: true,
            speed: 4,
            straight: false
          },
          number: { density: { enable: true, area: 50 }, value: 6 },
          opacity: {
            random: true,
            value: 0.5
          },
          shape: {
            type: "circle"
          },
          size: {
            random: true,
            value: 5
          }
        },
        detectRetina: true
      }}
    />

    );

};
export default ParticlesBackground